module.exports = __webpack_public_path__ + "static/media/logo.f8d0079d.png";